/**
 * SIMPS Drink Lab — fallbackRecipes.js
 * Tier 3 ("Dash's Lab Favourites") curated fallback recipe IDs, keyed by
 * drinkType. Used ONLY when the recommendation engine finds zero eligible
 * (drink-type-compatible, hard-filter-passing) recipes for the customer's
 * answers — e.g. a Sugar-Free-only combination that empties the eligible
 * pool for that category.
 *
 * Deliberately curated by hand, NOT derived from scoring or merchandising
 * boosts — these are "safe bets" per category, picked for broad appeal
 * (lower familiarity = more mainstream). Never crosses drink categories:
 * Coffee only pulls from Coffee, Mocktail only from Mocktail, etc.
 *
 * classic_soda is intentionally absent — that branch is served by
 * recommendClassicSoda() against CLASSIC_SODA_PRODUCTS, a separate system
 * from this recipe registry.
 */
window.DrinkLab = window.DrinkLab || {};

window.DrinkLab.FALLBACK_RECIPES = {
  coffee: ['DL-001', 'DL-002', 'DL-006'],
  custom_soda: ['DL-009', 'DL-008', 'DL-011'],
  lemonade: ['DL-012', 'DL-013', 'DL-015'],
  sparkling: ['DL-017', 'DL-018', 'DL-019'],
  creamy: ['DL-020', 'DL-021', 'DL-022'],
  iced_tea: ['DL-023', 'DL-024', 'DL-025'],
  mocktail: ['DL-026', 'DL-027', 'DL-029'],
  cocktail: ['DL-033', 'DL-034', 'DL-032']
};
